export default "__VITE_ASSET__CqVrVnrk__"